export default class RoutePointData {
    constructor(
        position,
        latitude = null,
        longitude = null,
        portCode = null,
    ) {
        this.position = position,
            this.latitude = latitude,
            this.longitude = longitude,
            this.portCode = portCode
    }
}